export default __webpack_public_path__ + "static/media/clock-icon.1b5d8848.svg";